// eslint-disable-next-line import/prefer-default-export
export enum Store {
  default = 'default',
  en = 'pul_en',
  de = 'pul_de',
  fr = 'pul_fr',
  es = 'pul_es',
}
// TODO: Change to Pullman store after some products are imports and scandiweb top menu is created
